/* eslint-disable */
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Box, Flex, HStack, Text, useColorModeValue } from '@chakra-ui/react';

export function SidebarLinks(props) {
  let location = useLocation();

  let activeColor = useColorModeValue('gray.700', 'white');
  let inactiveColor = useColorModeValue(
    'secondaryGray.600',
    'secondaryGray.600',
  );
  let activeIcon = useColorModeValue('brand.500', 'white');
  let textColor = useColorModeValue('secondaryGray.500', 'white');
  let brandColor = useColorModeValue('brand.500', 'brand.400');

  const { routes, collapsed } = props;

  const activeRoute = (routeName) => location.pathname.includes(routeName);

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.category) {
        if (collapsed) return null; // hide headings when collapsed

        return (
          <React.Fragment key={index}>
            <Text
              fontSize={'md'}
              color={activeColor}
              fontWeight="bold"
              ps="16px"
              pt="18px"
              pb="12px"
            >
              {route.name}
            </Text>
            {createLinks(route.items)}
          </React.Fragment>
        );
      }

      if (route.layout === '/admin') {
        const isActive = activeRoute(route.path.toLowerCase());

        return (
          <NavLink key={index} to={route.layout + route.path}>
            <Box>
              <HStack
                spacing={collapsed ? '0px' : isActive ? '22px' : '26px'}
                py="10px"
                px={collapsed ? '0px' : '10px'}
                justify={collapsed ? 'center' : 'flex-start'}
              >
                <Flex
                  w="100%"
                  align="center"
                  justify={collapsed ? 'center' : 'flex-start'}
                >
                  {/* ICON */}
                  <Box
                    color={isActive ? activeIcon : textColor}
                    me={collapsed ? '0px' : '18px'}
                    fontSize="20px"
                  >
                    {route.icon}
                  </Box>

                  {/* TEXT */}
                  {!collapsed && (
                    <Text
                      me="auto"
                      color={isActive ? activeColor : textColor}
                      fontWeight={isActive ? 'bold' : 'normal'}
                      whiteSpace="nowrap"
                    >
                      {route.name}
                    </Text>
                  )}
                </Flex>

                {/* ACTIVE BAR */}
                {!collapsed && (
                  <Box
                    h="36px"
                    w="4px"
                    bg={isActive ? brandColor : 'transparent'}
                    borderRadius="5px"
                  />
                )}
              </HStack>
            </Box>
          </NavLink>
        );
      }

      return null;
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;
